"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBRoleSettingComponent = void 0;
const _ = require("underscore");
const bbroles_service_1 = require("../../shared/services/bbroles.service");
class CSBBRoleSettingComponent {
    constructor(rolesService) {
        this.rolesService = rolesService;
    }
    ngOnInit() {
        this.rolesService.getRolesAndPermissions().subscribe((rolesInfo) => {
            this.getRollsArray = rolesInfo.Role;
        });
    }
    roleSetting(roleArray) {
        this.finalRolesArray = _.intersection(roleArray, this.getRollsArray);
        if (this.finalRolesArray.length !== 0) {
            return this.finalRolesArray[0];
        }
    }
}
exports.CSBBRoleSettingComponent = CSBBRoleSettingComponent;
//# sourceMappingURL=role-setting.component.js.map